import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { memo, useMemo } from 'react';
import clsx from 'clsx';
import { useRouter } from 'next/dist/client/router';
import { getSiteHeaderVariant } from '../../store/slices/user';
import HeaderVariant from '../../constants/HeaderVariant';
import { logoLayoutVariants, PageLinks } from '../../constants';

const AgencyLogo = ({ doShowOriginalLogo, className, agencyLogoOverride }) => {
  const { travelAgency } = useSelector((store) => store.user);
  const agencyAdditionalLogo = travelAgency && travelAgency.settings
    && travelAgency.settings.agencyAdditionalLogo;
  const headerVariant = useSelector(getSiteHeaderVariant);
  const doShowWithBrandingTopBar = headerVariant === HeaderVariant.withBrandingTopBar;
  const router = useRouter();
  const isLoginPage = router.pathname === PageLinks.Login.url;
  const doHideAgencyAdditionalLogo = !isLoginPage && travelAgency && travelAgency.settings
    && travelAgency.settings.logoLayoutVariant === logoLayoutVariants.LOGO_IMAGE_VARIANT_CENTERED;

  const agencyAdditionalLogoNode = useMemo(() => {
    if (!agencyAdditionalLogo || doHideAgencyAdditionalLogo) return null;

    const isSvg = typeof agencyAdditionalLogo === 'string' && agencyAdditionalLogo.startsWith('svg:');
    if (isSvg) {
      const cleanSvg = agencyAdditionalLogo.replace(/^svg:/, '');
      return (<div dangerouslySetInnerHTML={{ __html: cleanSvg }} />);
    }
    return (<img className="h-8 md:h-10" src={agencyAdditionalLogo} alt="agency logo" />);
  }, [agencyAdditionalLogo, doHideAgencyAdditionalLogo]);

  if (!travelAgency) return <></>;

  return doShowOriginalLogo ? (
    <div className={clsx('flex items-start lg:items-center', {
      'justify-between': agencyAdditionalLogo,
      'justify-center': !agencyAdditionalLogo,
      'md:flex-row lg:gap-12 gap-6': doShowWithBrandingTopBar,
      'flex-col gap-12 lg:gap-84 sm:px-6': isLoginPage && doShowWithBrandingTopBar,
      'lg:gap-24 xl:gap-64': !isLoginPage && doShowWithBrandingTopBar,
      'flex-col gap-2': !doShowWithBrandingTopBar,
    })}
    >
      <img src={agencyLogoOverride || travelAgency.agencyOriginalLogo} alt="agency logo" className={className} />
      {agencyAdditionalLogoNode}
    </div>

  ) : (
    <div dangerouslySetInnerHTML={{ __html: travelAgency.agencySvgLogo }} className={className} />
  );
};

AgencyLogo.propTypes = {
  doShowOriginalLogo: PropTypes.bool,
  className: PropTypes.string,
  agencyLogoOverride: PropTypes.string,
};

AgencyLogo.defaultProps = {
  doShowOriginalLogo: false,
  className: undefined,
  agencyLogoOverride: undefined,
};

export default memo(AgencyLogo);
